import React from 'react'

type PropsT = {
  className?: string
  fillColor?: string
}

// Overview hero's third benefit bullet ("You choose how much to show") —
// Sketch prototype uses a pencil glyph there, not a settings gear.
const Pencil = ({ className = '', fillColor = 'currentColor' }: PropsT) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z"
      fill={fillColor}
    />
  </svg>
)

export default Pencil
